/** 
* 自动生成文件，请勿修改 
* @name: 职位:员工晋升考核表-各维度打分记录
* @description: 员工晋升考核表-各维度打分记录（三期新增）
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:7条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const scoreRecord = { 
	/** 1 summary:删除-单条	method:post */ 
	delete : new APIObject("/api/scoreRecord/delete.do"), 
	/** 2 summary:保存/修改-批量	method:post */ 
	batchSaveOrUpd : new APIObject("/api/scoreRecord/batchSaveOrUpd.do"), 
	/** 3 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/scoreRecord/batchDelete.do"), 
	/** 4 summary:查询-单条(根据主键)	method:post */ 
	queryOne : new APIObject("/api/scoreRecord/queryOne.do"), 
	/** 5 summary:查询-分页	method:post */ 
	queryPage : new APIObject("/api/scoreRecord/queryPage.do"), 
	/** 6 summary:保存/修改-单条	method:post */ 
	saveOrUpd : new APIObject("/api/scoreRecord/saveOrUpd.do"), 
	/** 7 summary:查询-不分页	method:post */ 
	queryAll : new APIObject("/api/scoreRecord/queryAll.do"), 
};
export default scoreRecord;